import { Entity, IEntity } from "./Entity";

export interface IRiskAppIncidentIssue extends IEntity {
    IssueID?: number;
    IncidentID?: number;
}

export class RiskAppIncidentIssue extends Entity implements IRiskAppIncidentIssue {
    public IssueID = null;
    public IncidentID = null;
}